module.exports = __webpack_public_path__ + "static/media/phone_songs.cf744b13.png";